// extracted by mini-css-extract-plugin
export default {"input_wrapper":"CheckPassword_input_wrapper__jt-9R","error_msg":"CheckPassword_error_msg__FbsqK"};